// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"6c55ba20","703":"f051f6f0","787":"2ac6aa76"}[chunkId] + ".chunk.js";
};